import React, { forwardRef } from 'react';
import { styled, Menu } from '@mui/material';

const CustomMenu = styled(Menu)(({ theme }) => {
    return {
        '& .MuiBackdrop-root': {
            background: 'transparent',
        },
        '& .MuiPaper-root': {
            boxShadow: theme.palette.ensightful.shadows[1],
        },
        '& .MuiList-root': {
            padding: theme.spacing(2),
        },
    };
});

export default forwardRef((props, ref) => {
    return <CustomMenu ref={ref} {...props} />;
});
